export default "__VITE_ASSET__COGDE1hQ__"